import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class PwaService {
  private deferredPrompt: any;
  private installPromptSubject = new BehaviorSubject<boolean>(false);
  public readonly installPrompt$ = this.installPromptSubject.asObservable();

  constructor() {
    window.addEventListener('beforeinstallprompt', (event: any) => {
      event.preventDefault();
      this.deferredPrompt = event;
      this.installPromptSubject.next(true);
    });
  }

  promptInstall(): Promise<void> {
    if (!this.deferredPrompt) return Promise.reject('No install prompt available');
    const prompt = this.deferredPrompt;
    this.deferredPrompt = null;
    this.installPromptSubject.next(false);
    return prompt.prompt().then(() => prompt.userChoice);
  }
}
